import { render, staticRenderFns } from "./GeolapseThumbnail.vue?vue&type=template&id=7ef1a4dd&scoped=true&"
import script from "./GeolapseThumbnail.vue?vue&type=script&lang=js&"
export * from "./GeolapseThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./GeolapseThumbnail.vue?vue&type=style&index=0&id=7ef1a4dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef1a4dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
